function initializeUtilsFunctions(){
    if (!window.publish){
        function publish(fn, name) {
            name = name || fn.name;
            window[name] = fn;
        }

        function elementInViewport(el) {
            let top = el.offsetTop;
            let left = el.offsetLeft;
            let width = el.offsetWidth;
            let height = el.offsetHeight;
    
            while (el.offsetParent) {
                el = el.offsetParent;
                top += el.offsetTop;
                left += el.offsetLeft;
            }
    
            return (
                top >= window.pageYOffset &&
                left >= window.pageXOffset &&
                (top + height) <= (window.pageYOffset + window.innerHeight) &&
                (left + width) <= (window.pageXOffset + window.innerWidth)
            );
        }
    
        
        function trigger(el, eventName, data) {
            let event;
            data = data || {};
    
            if (window.CustomEvent) {
                event = new CustomEvent(eventName, data);
                el.dispatchEvent(event);
            }
        }

        function debounce(func, wait, immediate) {
            let timeout;
            return function () {
                let context = this, args = arguments;
                let later = function () {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                let callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        }
    
        function executeOnce (key, fn) {
            if (!window.timer){
                window.timer = {};
            }
            if (!window.once_settings){
                window.once_settings = {};
            }
            if (window.timer[key]) {
                window.clearTimeout(window.timer[key]);
            }
            timer[key] = window.setTimeout(function () {
                if (!window.once_settings[key]) {
                    window.once_settings[key] = true;
                    if (typeof(fn) == "function"){
                    fn();
                    }
                }
            }, 350);

        };

        window.publish = publish;
        publish(executeOnce, "executeOnce");
        publish(trigger, "trigger");
        publish(debounce, "debounce");
        publish(elementInViewport, "elementInViewport");
    }
    
}
